import showNotification from "./showNotification";
import clearNotification from "./clearNotification";

export { showNotification, clearNotification };

export default { showNotification, clearNotification };